var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"fixed-amount field"},[_c('header',{staticClass:"field__title"},[_vm._v("Сумма к оплате")]),_c('div',{staticClass:"fixed-amount__amount"},[_c('money',{attrs:{"value":_vm.amount}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }